export default "__VITE_ASSET__CVsTJYqz__"